import { LogLevel } from '@azure/msal-browser';

export const b2cPolicies = {
	names: {
		SignIn: `${process.env.REACT_APP_AZURE_B2C_SIGNIN}`,
		passwordReset: `${process.env.REACT_APP_AZURE_B2C_PASSWORDRESET}`,
	},
	authorities: {
		SignIn: {
			authority: `${process.env.REACT_APP_AZURE_B2C_AUTHORITY}/${process.env.REACT_APP_AZURE_B2C_SIGNIN}`,
		},
		passwordReset: {
			authority: `${process.env.REACT_APP_AZURE_B2C_AUTHORITY}/${process.env.REACT_APP_AZURE_B2C_PASSWORDRESET}`,
		},
	},
	authorityDomain: `${process.env.REACT_APP_AZURE_B2C_DOMAIN}`,
};

export const msalConfig = {
	auth: {
		clientId: `${process.env.REACT_APP_MSAL_CLIENT_ID}`,
		authority: b2cPolicies.authorities.SignIn.authority,
		knownAuthorities: [b2cPolicies.authorityDomain],
		redirectUri: process.env.NODE_ENV == 'production'
			? `${process.env.REACT_APP_ORIGIN}/`
			: `${process.env.REACT_APP_LOCAL_ORIGIN}/`,
		postLogoutRedirectUri: process.env.NODE_ENV == 'production'
			? `${process.env.REACT_APP_ORIGIN}/`
			: `${process.env.REACT_APP_LOCAL_ORIGIN}/`,
		navigateToLoginRequestUrl: false, // Let React Router handle navigation
	},
	cache: {
		cacheLocation: 'localStorage',
		storeAuthStateInCookie: true, // Better refresh token handling
	},
	system: {
		loggerOptions: {
			loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
				if (containsPii) return;
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						// console.info(message);
						return;
					case LogLevel.Verbose:
						console.debug(message);
						return;
					case LogLevel.Warning:
						console.warn(message);
						return;
				}
			},
			logLevel: process.env.NODE_ENV === 'development' ? LogLevel.Info : LogLevel.Warning,
		},
		allowNativeBroker: false,
		windowHashTimeout: 60000,
		iframeHashTimeout: 6000,
		// Better token refresh handling
		asyncPopups: false,
	},
};

// Reserved scopes that should not have the base URL prepended
const RESERVED_SCOPES = ['openid', 'offline_access', 'profile', 'email'];

export const loginRequest = {
	scopes: `${process.env.REACT_APP_AZURE_B2C_SCOPE}`
		.split(',')
		.map((scope) => {
			const trimmedScope = scope.trim();
			// Don't prepend base URL for reserved scopes
			if (RESERVED_SCOPES.includes(trimmedScope)) {
				return trimmedScope;
			}
			// Prepend base URL for custom scopes
			return `${process.env.REACT_APP_AZURE_B2C_SCOPEBASEURL}${trimmedScope}`;
		}),
	redirectUri: process.env.NODE_ENV == 'production'
		? `${process.env.REACT_APP_ORIGIN}/`
		: `${process.env.REACT_APP_LOCAL_ORIGIN}/`,
};